import React from "react"
import PropTypes from "prop-types"
import {
  FOLLOWED_TASKS_SORT_OPTIONS,
  TASKS_STATES,
} from "../../../../consts/modules/pendingTasks.consts"
import InputSearch from "../../../../components/molecules/InputSearch.molecule"
import TaskProjectDropdown from "../../../pendingTasks/components/TaskProjectDropdown.compound"
import TaskTeamMemberDropdown from "../../../pendingTasks/components/TaskTeamMemberDropdown.compound"
import TaskStateDropdown from "../../components/TaskStateDropdown.compound"
import CustomSortOverlay from "../../components/CustomSortOverlay.compound"

const FolowedTasksControls = ({
  sortConfig,
  setSortConfig,
  globalFilter,
  setGlobalFilter,
  loadingData,
  projects,
  selectedProjects,
  setSelectedProjects,
  teamMembers,
  selectedTeamMembers,
  setSelectedTeamMembers,
  selectedStates,
  setSelectedStates,
}) => {
  return (
    <div
      className={`followed-tasks-controls flex flex-1 justify-content-between align-items-center gap-3 ${globalFilter === "" ? "mb-4" : "mb-3"}`}
    >
      <div className="dropdown-controls flex">
        <InputSearch
          value={globalFilter}
          onChange={(e) => setGlobalFilter(e.target.value)}
          placeholder="Buscar"
          className="historical-pending-tasks-search"
        />
        <TaskProjectDropdown
          projects={projects}
          selectedProjects={selectedProjects}
          setSelectedProjects={setSelectedProjects}
          loading={loadingData}
        />
        <TaskTeamMemberDropdown
          teamMembers={teamMembers}
          selectedTeamMembers={selectedTeamMembers}
          setSelectedTeamMembers={setSelectedTeamMembers}
        />
        <TaskStateDropdown
          states={TASKS_STATES}
          selectedStates={selectedStates}
          setSelectedStates={setSelectedStates}
        />
      </div>
      <CustomSortOverlay
        sortConfig={sortConfig}
        setSortConfig={setSortConfig}
        sortConfigOptions={FOLLOWED_TASKS_SORT_OPTIONS}
      />
    </div>
  )
}

export default FolowedTasksControls

FolowedTasksControls.propTypes = {
  globalFilter: PropTypes.string,
  setGlobalFilter: PropTypes.func,
}
